/* import __COLOCATED_TEMPLATE__ from './card-settings-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();